import JSDB from '../fromKotlin/nk';

export const REP_LINK_FEATURE = {
    DRIVER: 1,
    CLIENT_SIGNUP: 2,
    BTC: 4,
} as const;

/** Paid external-link features enabled through the cofc_conf.rep_link bitmask. */
export function getRepLinkFlags() {
    const v = Number((JSDB().userCofcConf as { rep_link?: number } | null)?.rep_link ?? 0);
    return {
        driver: (v & REP_LINK_FEATURE.DRIVER) !== 0,
        clientSignup: (v & REP_LINK_FEATURE.CLIENT_SIGNUP) !== 0,
        btc: (v & REP_LINK_FEATURE.BTC) !== 0,
        value: v,
    };
}
